import { render, staticRenderFns } from "./SubscriptionForm.PurchaseOption.vue?vue&type=template&id=22861c5d&scoped=true&"
import script from "./SubscriptionForm.PurchaseOption.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.PurchaseOption.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionForm.PurchaseOption.vue?vue&type=style&index=0&id=22861c5d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22861c5d",
  null
  
)

export default component.exports